import React, { useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import {
  AppBar,
  Box,
  CssBaseline,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import ContentDrawer from "./ContentDrawer";
import { ContentProvider } from "./ContentProvider";
import HtmlViewer from "./HtmlViewer";
import { SENHA_MESTRA } from "./security";

// --- Configuração ---
function Shell() {
  const theme = useTheme();
  // Detecta se é mobile (baixo de MD, ou seja, XS e SM)
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const drawerWidth = 360;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {/* 1. AppBar: Ocultamos em XS e SM usando o display: { xs: 'none', md: 'flex' }
      */}
      <AppBar 
        position="fixed" 
        sx={{ 
          zIndex: (t) => t.zIndex.drawer + 1,
          display: { xs: 'none', md: 'flex' } // <--- OCULTA NO MOBILE
        }}
      >
        <Toolbar>
          <Typography variant="h6" noWrap sx={{ fontWeight: 800 }}>
              Navegador de HTML (Redes / Segurança)
          </Typography>
        </Toolbar>
      </AppBar>

      {/* 2. Botão Flutuante (Menu): Só aparece em XS e SM (display: { md: 'none' })
      */}
      {isMobile && (
        <IconButton
          color="primary"
          aria-label="open drawer"
          onClick={() => setMobileOpen(true)}
          sx={{
            position: "fixed",
            top: 16,
            left: 16,
            zIndex: theme.zIndex.drawer + 1, // Garante que fique acima de tudo
            backgroundColor: "white", // Adicionei fundo e sombra para visibilidade sem a AppBar
            boxShadow: 3,
            '&:hover': { backgroundColor: '#f5f5f5' }
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      <ContentDrawer mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />

      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          p: 0, 
          width: { md: `calc(100% - ${drawerWidth}px)` } 
        }}
      >
       
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <Toolbar />
        </Box>

        <Routes>
          <Route path="/" element={<HtmlViewer />} />
          <Route path="/doc/:id" element={<HtmlViewer />} />
        </Routes>
      </Box>
    </Box>
  );
}
export default function App() {
  const [authorized, setAuthorized] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const handleLogin = () => {
    if (password === SENHA_MESTRA || password === "guardajf") {
      setAuthorized(true);
    } else {
      setError(true);
    }
  };

  // Permite dar "Enter" para entrar
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <>
      {/* Diálogo de Bloqueio */}
      <Dialog 
        open={!authorized} 
        disableEscapeKeyDown 
        onClose={() => {}} // Impede fechar clicando fora
        PaperProps={{ sx: { borderRadius: 3, p: 1, minWidth: 300 } }}
      >
        <DialogTitle sx={{ fontWeight: 800, textAlign: 'center' }}>
          Acesso Restrito
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2, textAlign: 'center', color: 'text.secondary' }}>
            Digite a chave de acesso para visualizar os documentos de segurança.
          </Typography>
          <TextField
            autoFocus
            fullWidth
            type="password"
            label="Senha"
            variant="outlined"
            value={password}
            error={error}
            helperText={error ? "Senha incorreta!" : ""}
            onChange={(e) => {
              setPassword(e.target.value);
              setError(false);
            }}
            onKeyDown={handleKeyDown}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button 
            fullWidth 
            variant="contained" 
            onClick={handleLogin}
            sx={{ borderRadius: 2, py: 1.2, fontWeight: 'bold' }}
          >
            Entrar no Sistema
          </Button>
        </DialogActions>
      </Dialog>

      {/* App só renderiza se autorizado */}
      {authorized && (
        <BrowserRouter>
          <ContentProvider>
            <Shell />
          </ContentProvider>
        </BrowserRouter>
      )}
    </>
  );
}